import { EyeIcon } from '@common_components/icons/eye.icon';
import { BaseModal, BodyConfirmModal, RootState, UUID } from '@umanforge/common';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { VisualisationService } from 'services/visualisation.service';

type ActivationVisualisationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  callback?: () => void;
  sectorId?: UUID
  eventManagersId?: UUID[];
}

const ActivationVisualisationModal: React.FC<ActivationVisualisationModalProps> = ( { isOpen, onClose, callback, sectorId, eventManagersId }: ActivationVisualisationModalProps ) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );

  return (
    <BaseModal
      title={ t( 'translation:visualisation' ) }
      icon={ <EyeIcon className='w-[36px] h-[36px] p-[4px] text-white' /> }
      iconColor='#1e40af'
      isOpen={isOpen}
      onClose={onClose}
    >
      <BodyConfirmModal
        confirmColor='#5081f0'
        confirmColorHover='#5081f0'
        onCancel={ onClose }
        onConfirm={ () => {
          VisualisationService.active( eventManagersId, sectorId, token, dispatch )
            .then( () => {
              if ( callback ) {
                callback();
              }
              onClose();
            } );
        } }
      >
        <div className='flex flex-col w-full h-full p-2 text-[16px] font-[458] text-gray-600'>
          <span className=''>
            { t( 'translation:switch_to_visualisation_mode' ) }
          </span>
          <span className=''>
            { t( 'translation:you_are_about_to_be_logged' ) }
          </span>
        </div>
      </BodyConfirmModal>
    </BaseModal>
  );
};

export default ActivationVisualisationModal;